/* @flow */

import React, { Component } from 'react';

import HeaderRow from './headerRow';
import SubHeaderRow from './subHeaderRow';

var speakerId;
var tab;

function sortSessions(sessions) {
  sessions.sort(function (a, b) {
    if (a.category === b.category) {
      if (a.date === b.date) {
        if (a.startTime === b.startTime) {
            return a.venue < b.venue ? -1: 1;
        } else {
          return a.startTime < b.startTime ? -1 : 1;
        }
      } else {
        return a.date < b.date ? -1 : 1;
      }
    } else {
      if ((a.category.toLowerCase() === 'invited') || ((a.category.toLowerCase() === 'sponsored symposium') && (b.category.toLowerCase() === 'submitted'))) {
        return -1;
      } else {
        return 1;
      }
    }
  });
  return sessions;
}



function sortChairmans(chairmans) {
  chairmans.sort(function (a, b) {
    if (a.lastName === b.lastName) {
      return a.firstName > b.firstName ? 1 : -1;
    } else {
      return a.lastName > b.lastName ? 1 : -1;
    }
  });
  return chairmans;
}


function formatName(options) {
  options = options || {};
  var names = [];

  if (options.firstName && !options.firstName.trim().isEmpty()) {
    var firstName = options.firstName.trim().toTitleCase();
    if (firstName.indexOf(". ") !== -1) {
      firstName = firstName.replace(". ", ".");
    }
    if (firstName.indexOf("-") !== -1) {
      var firstNames = firstName.split("-");
      firstName = firstNames[0] + "-" + firstNames[1].toLowerCase();
    }
    names.push(firstName);
  }

  // last name
  if (options.lastName && !options.lastName.trim().isEmpty()) {
    names.push(options.lastName.trim().toUpperCase());
  }

  return names.join(" ");
}


function getChairs(session) {
  var chairs=[];
  var chairmans = sortChairmans(session.chairmans);
  chairmans.forEach(function (chairman) {

    var displayName = formatName(chairman);
    chairs.push(<Text text={displayName} />);
  });
  return chairs;
}

function getInvolvements(session) {
  var involvements=[];
  var isChairman = false, isSpeaker = false, isPanelist = false;
  session.chairmans.forEach(function (chairman) {
    if (chairman.id === speakerId) { isChairman = true;}
  });
  session.panelists.forEach(function (panelist) {
    if (panelist.id === speakerId) { isPanelist = true;}
  });
  session.topics.forEach(function (topic) {
    topic.speaker.forEach(function (speaker) {
      if (speaker.id === speakerId) { isSpeaker = true;}
    });
  });
  if (isChairman) { involvements.push(<Text text="Chair" />);}
  if (isPanelist) { involvements.push(<Text text="Panelist" />);}
  if (isSpeaker) { involvements.push(<Text text="Speaker" />); }
  return involvements;
}

function getTopics(session) {
  var topics=[];
  session.topics.forEach(function (topic) {
    topic.name = topic.name || '';
    topic.speaker.forEach(function (speaker) {
      if (speaker.id === speakerId) {
        topics.push(<tr><td>{topic.sequence}.&nbsp;</td><td>{topic.name.trim()}</td></tr>);
      }
    });
  });
  return topics;
}



class Text extends Component {
  render() {
    return (
      <div className="text">{this.props.text}</div>
    );
  }
}

class Session extends Component {
  onClick() {
    window.open('/schedule/#'+ this.code);
  }
  render() {
    var session = this.props.session;
    if (tab === 3) {
      var involvements = getInvolvements(session);
      var topics = getTopics(session);
      return (
        <tr className={this.props.className}>
          <td className="center nowrap blue">{session.date}</td>
          <td className="center nowrap blue">{session.startTime}<br />|<br />{session.endTime}</td>
          <td className="center nowrap venue">{session.venue}</td>
          <td>{session.subspecialty}</td>
          <td>{session.type}</td>
          <td className="link" onClick={this.onClick.bind(session)}>{session.theme}</td>
          <td className="nowrap">{involvements}</td>
          <td><table className="session-topic">{topics}</table></td>
        </tr>
      );
    } else {
      var chairs = getChairs(session);
      return (
        <tr className={this.props.className}>
          <td className="center nowrap blue">{session.date}</td>
  				<td className="center nowrap blue">{session.startTime}<br />|<br />{session.endTime}</td>
          <td className="center nowrap venue">{session.venue}</td>
          <td>{session.subspecialty}</td>
          <td>{session.type}</td>
          <td className="link" onClick={this.onClick.bind(session)}>{session.theme}</td>
  				<td className="nowrap">{chairs}</td>
  			</tr>
      );
    }
  }
}



export default class SessionList extends Component {
  render() {
    tab = this.props.tab;
    speakerId = this.props.speakerId;
    var invitedSessions =[], sponsoredSessions=[], submittedSessions = [];
    var sessions = sortSessions(this.props.sessions);
    var dateTime;
    var className;
    var index = 1;
    sessions.forEach(function (session) {
      var newDateTime = session.date + session.startTime;
      if (dateTime !== newDateTime) {
        dateTime = newDateTime;
        index = index * -1;
      }
      className = 'bkgClass' + index;

      if (session.category.toLowerCase() === 'invited') {
        invitedSessions.push(<Session key={session.code} session={session} className={className} />);
      }
      if (session.category.toLowerCase() === 'sponsored') {
        sponsoredSessions.push(<Session key={session.code} session={session} className={className} />);
      }
      if (session.category.toLowerCase() === 'submitted') {
        submittedSessions.push(<Session key={session.code} session={session} className={className} />);
      }
    });
    var list = [];
    if (invitedSessions.length > 0) {
      list.push(<HeaderRow tab={tab} title="Invited" />);
      list.push(<SubHeaderRow tab={tab} />);
      list.push(invitedSessions);
    }
    if (sponsoredSessions.length > 0) {
      list.push(<HeaderRow tab={tab} title="Sponsored Symposium" />);
      list.push(<SubHeaderRow tab={tab} />);
      list.push(sponsoredSessions);
    }
    if (submittedSessions.length > 0) {
      list.push(<HeaderRow tab={tab} title="Submitted" />);
      list.push(<SubHeaderRow tab={tab} />);
      list.push(submittedSessions);
    }
    return (
      <div className="Scheduler">
        <div className="SessionList">
          <table className="table table-bordered table-hover table-striped">
            <tbody>
              {list}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/sessionList.js
 **/